import { Tag } from "./ds";
import { streakLabel } from "../../lib/format";

// v34 — malé štatistické štítky vedľa titulku „DNES · <deň>" v hlavičke. Prepoužívajú primitív
// Tag; farby preberajú z rovnomenných dlaždíc v Štatistikách, nech je to jeden vizuálny jazyk:
//   • denná séria       — tón „flame"  (bledé pozadie + text vo farbe progres pruhu dlaždice
//                         „Dni v sérii") + ikona plamienka; ťuknutie otvorí popup Denná séria
//   • perfektné dni     — tón „growth" (farby dlaždice „Perfektné dni po sebe") + ikona terča,
//                         hodnota = koľko perfektných dní PO SEBE (vrátane dnešného, ak je už
//                         perfektný); ťuknutie otvorí popup Perfektné dni
//   • body na míňanie   — tón „outline" ako denný návyk (biele pozadie + jemný okraj, čierna ikona
//                         mincí); ťuknutie otvorí Obchod za body
// Popupy sa otvárajú NA MIESTE (žiadny presun na Prehľad) — sú to tie isté okná, ktoré otvárajú
// dlaždice v Prehľade (StatModals.jsx).
// Celý rad je len pre non-Lite používateľov (Lite nemá body ani sledovanie série v hlavičke).
// v31 — séria aj perfektné dni nesú JEDNOTKU („5 dní"), nie holé číslo: vedľa seba stáli tri
// čísla bez rozlíšenia a nedalo sa uhádnuť, čo ktoré znamená. Skloňovanie rieši `streakLabel`
// (1 deň · 2–4 dni · 5+ dní) — tá istá funkcia ako v StreakTag, aby sa tvary nerozišli.
// Body ostávajú holé číslo: „b." je pri nich v tooltipe a mincová ikona je jednoznačná.
export function HeaderTags({ s, onShop, onStreak, onPerfect }) {
  if (!s || s.lite_mode) return null;
  const streak = s.streak || 0;
  const perfect = (s.perfectStreak || 0) + (s.perfectToday ? 1 : 0);
  const points = s.spendable_points || 0;
  // v29.7 — oba štítky sú vidieť VŽDY (aj pri nule) a farba nesie stav, rovnako ako pri
  // sérii návyku v zozname: farebné = dnes už máš, sivé = ešte nie.
  // v30.3 — perfektné dni sa riadia PRESNE tým istým pravidlom ako denná séria: kým dnešok
  // nie je perfektný, štítok je sivý (predtým svietil aj vtedy, keď séria pochádzala len
  // z minulých dní, a vyzeralo to, akoby bolo dnes hotovo).
  const streakOn = streak > 0 && !!s.streakExtendedToday;
  const perfectOn = perfect > 0 && !!s.perfectToday;
  return (
    <span className="bz-htags">
      <Tag as="button" tone={streakOn ? "flame" : "neutral"} size="xs" icon="flame" onClick={onStreak}
        title={streakOn ? `Denná séria — ${streakLabel(streak)} po sebe`
          : streak > 0 ? `Denná séria — ${streakLabel(streak)}, dnes ešte nepredĺžená`
          : "Denná séria — zatiaľ žiadna"}>{streakLabel(streak)}</Tag>
      <Tag as="button" tone={perfectOn ? "growth" : "neutral"} size="xs" icon="target" onClick={onPerfect}
        title={perfectOn ? `Perfektné dni po sebe — ${streakLabel(perfect)}`
          : perfect > 0 ? `Perfektné dni po sebe — ${streakLabel(perfect)}, dnes ešte nepredĺžená`
          : "Perfektné dni po sebe — zatiaľ žiadne"}>{streakLabel(perfect)}</Tag>
      <Tag as="button" size="xs" tone="outline" icon="coins" onClick={onShop}
        title={`Máš ${points} b. na míňanie — otvoriť Obchod`} aria-label={`Body na míňanie: ${points}. Otvoriť Obchod`}>{points}</Tag>
    </span>
  );
}
